export default [
    {
        path: 'relatorio-exame-laboratorio-apoio',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-relatorio-exame-laboratorio-apoio' */
            '@/views/exame-laboratorial/relatorio-exame-laboratorio-apoio/Index'
        ),
        redirect: 'relatorio-exame-laboratorio-apoio/index',
        children: [
            {
                name: 'exame-laboratorial-relatorio-exame-laboratorio-apoio-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-relatorio-exame-laboratorio-apoio' */
                    '@/views/exame-laboratorial/relatorio-exame-laboratorio-apoio/List.vue'
                ),
            },
        ],
    }
]